export const PATH = {
    METHOD: ['method'],
    SMS_CODE: ['smsCode'],
    GRID_CODE: ['gridCode'],
    EMAIL_CODE: ['emailCode']
};
